import { render, staticRenderFns } from "./AppQrCodeEdit.vue?vue&type=template&id=070bd4e3&scoped=true&"
import script from "./AppQrCodeEdit.vue?vue&type=script&lang=js&"
export * from "./AppQrCodeEdit.vue?vue&type=script&lang=js&"
import style0 from "./AppQrCodeEdit.vue?vue&type=style&index=0&id=070bd4e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070bd4e3",
  null
  
)

export default component.exports